/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSelectionsByItemIdAdminResponse } from '../models/GetSelectionsByItemIdAdminResponse';
import type { PutSelectionAvailabilityOperatorRequest } from '../models/PutSelectionAvailabilityOperatorRequest';
import type { PutSelectionsAdminRequest } from '../models/PutSelectionsAdminRequest';
import type { PutSelectionSimpleValuePriceOperatorRequest } from '../models/PutSelectionSimpleValuePriceOperatorRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SelectionsService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateSelectionAvailabilityOperator({
        itemId,
        requestBody,
    }: {
        itemId: number,
        requestBody?: PutSelectionAvailabilityOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/selections/{itemId}/availability',
            path: {
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateSelectionPriceOperator({
        itemId,
        branchId,
        requestBody,
    }: {
        itemId: number,
        branchId: number,
        requestBody?: PutSelectionSimpleValuePriceOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/selections/{itemId}/price/{branchId}',
            path: {
                'itemId': itemId,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSelections`
     * @returns GetSelectionsByItemIdAdminResponse OK
     * @throws ApiError
     */
    public static getSelectionsByItemIdAdmin({
        itemId,
    }: {
        itemId: number,
    }): CancelablePromise<GetSelectionsByItemIdAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/selections/item/{itemId}',
            path: {
                'itemId': itemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSelections`
     * @returns any OK
     * @throws ApiError
     */
    public static putSelectionByItemIdAdmin({
        itemId,
        requestBody,
    }: {
        itemId: number,
        requestBody?: PutSelectionsAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/selections/item/{itemId}',
            path: {
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteSelections`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteSelectionAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/selections/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
